var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBellBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a92d0",
    d: "M13.471 13.573H3.743V7.087a4.87 4.87 0 0 1 4.864-4.864 4.87 4.87 0 0 1 4.864 4.864zm-4.864 3.243a1.623 1.623 0 0 1-1.621-1.622h3.243c0 .895-.728 1.622-1.622 1.622zm7.297-3.243h-.811V7.087A6.493 6.493 0 0 0 8.607.602a6.493 6.493 0 0 0-6.486 6.485v6.486h-.81a.81.81 0 1 0 0 1.621h4.053a3.246 3.246 0 0 0 3.243 3.243 3.246 3.246 0 0 0 3.243-3.243h4.054a.81.81 0 1 0 0-1.621z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellBlue);
export default __webpack_public_path__ + "static/media/icon-bell-blue.36ec520794513db6340d3cd979c27a7b.svg";
export { ForwardRef as ReactComponent };